import { cn } from "@/lib/utils";

/**
 * Page header: title + optional meta line + actions.
 * `eyebrow` is accepted for API compatibility but intentionally not rendered (no overlines).
 */
export const PageHeader = ({ eyebrow, title, description, meta, actions, className, children, testId }) => (
  <div className={cn("flex flex-col gap-4 md:flex-row md:items-end md:justify-between", className)} data-testid={testId}>
    <div className="min-w-0">
      <h1 className="text-[30px] font-semibold leading-[1.15] tracking-[-0.015em] text-foreground">{title}</h1>
      {description ? <p className="mt-1.5 max-w-2xl text-[15px] leading-relaxed text-muted-foreground">{description}</p> : null}
      {meta ? <div className="mt-1.5 text-[14px] text-muted-foreground">{meta}</div> : null}
      {children}
    </div>
    {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);

export const SectionTitle = ({ title, description, actions, className, as: Tag = "h2" }) => (
  <div className={cn("flex items-start justify-between gap-3", className)}>
    <div className="min-w-0">
      <Tag className="text-[16px] font-semibold tracking-[-0.01em] text-foreground">{title}</Tag>
      {description ? <p className="mt-0.5 text-[13.5px] text-muted-foreground">{description}</p> : null}
    </div>
    {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
  </div>
);

/** Panel header row: title left, actions right, hairline below. */
export const PanelHead = ({ title, description, actions, className }) => (
  <div className={cn("flex items-center justify-between gap-3 border-b border-border px-5 py-3", className)}>
    <div className="min-w-0">
      <h2 className="text-[15px] font-semibold tracking-[-0.01em] text-foreground">{title}</h2>
      {description ? <p className="mt-0.5 text-[13px] text-muted-foreground">{description}</p> : null}
    </div>
    {actions ? <div className="flex shrink-0 items-center gap-1.5">{actions}</div> : null}
  </div>
);
